/**
 * Lindy Quick Add Handler
 *
 * Handles quick add dialog events for Lindy-specific functionality
 * without modifying the core quick-add.js file.
 *
 * Dispatches custom events to product cards to show the overlay when items are added.
 */

import { CartAddEvent } from '@theme/events';

class LindyQuickAddHandler {
  constructor() {
    this.init();
  }

  init() {
    // Listen for cart add events at the document level
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  /**
   * Handles cart add events from quick add dialogs
   * @param {CustomEvent} event - The cart add event
   */
  #handleCartAdd = (event) => {
    if (!(event.target instanceof Element)) return;

    // Check if the add came from a quick add dialog
    const quickAddDialog = event.target?.closest('quick-add-dialog');
    if (!quickAddDialog) return;

    // Find the parent product card
    const productCard = quickAddDialog.closest('product-card');
    if (!productCard) return;

    // Extract data from the event
    const { data } = event.detail;
    if (data?.didError) return;

    // Dispatch custom event to product card for overlay display
    productCard.dispatchEvent(new CustomEvent('product-card:added', {
      bubbles: true,
      detail: {
        itemCount: data?.itemCount || 1,
        productId: data?.productId,
      }
    }));
  };

  destroy() {
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }
}

// Initialize the handler
const lindyQuickAddHandler = new LindyQuickAddHandler();

// Export for potential cleanup
export default lindyQuickAddHandler;
